<template>
  <ul class="tag-list">
    <li
      v-for="(tag, index) in tagList"
      :class="getClass(tag)"
      :key="index"
      :style="{
        width: tag.width + '%',
        'text-align': 'center'
      }"
    >
      <!-- 课前学模块 -->
      <div v-if="tag.id === 6" class="other-info">
        <div class="name">
          {{ tag.name }}
        </div>
        <div
          class="time-box"
          v-if="!!tag.isHighlight"
          :style="{background: tag.isHighlight === 1 ? '#3A3C48' : 'none'}"
        >
          <span class="time-icon" v-show="tag.isHighlight === 1">
            <span />
            <span />
            <span />
          </span>
          <!-- // 1：看课中，2：已看完 -->
          <span v-if="tag.isHighlight === 2" style="color: #98a2b2">已学完</span>
          <span v-else style="display: flex; margin-left: 4px">学习中</span>
        </div>
      </div>

      <!-- 看AI课 -->
      <div v-if="tag.id === 1" class="progress-wrap">
        <progress class="progress" :value="(aiInfo && aiInfo.progressVal) || 0" max="100" />
        <SvgIcon v-if="hasBeforeTag" icon="supervision-arrow-right" class="arrow-right-style" />
        <span class="learn-ai">
          <a-tooltip placement="topLeft" :title="aiInfo && aiInfo.isOldData ? '学AI课' : aiInfo && aiInfo.fragmentName || '--'" overlay-class-name="draw_atooltip">
            {{ aiInfo && aiInfo.isOldData ? '学AI课' : aiInfo && aiInfo.fragmentName || '--' }}
          </a-tooltip>
        </span>
        <div
          v-if="aiInfo && (aiInfo.totalTime || aiInfo.totalTime)"
          class="time-box"
        >
          <!-- 已学完 -->
          <span v-if="aiInfo && aiInfo.isFinishAi" style="color: #98a2b2">已学完</span>
          <!--
            关于白机构和非白机构的区别，后端处理了。
            studyTime/totalTime(当前学习时长/学习总时长); endPartNum/totalPartNum(学过片段数量/总共片段数量)
          -->
          <div v-else-if="aiInfo && !aiInfo.isFinishAi && !aiInfo.isOldData" style="width: 100%;">
            <!-- 老数据不展示总进度：aiInfo.isOldData -->
            <div class="total-progress" style="background: #3A3C48">
              <span class="time-icon">
                <span />
                <span />
                <span />
              </span>
              {{ aiInfo && aiInfo.endPartNum || '-' }}/{{ aiInfo && aiInfo.totalPartNum || '-' }}段
            </div>
            <span>
              <span class="timer">{{ aiInfo && aiInfo.studyTime || '-' }}</span>
              <span class="total">/{{ aiInfo && aiInfo.totalTime || '-' }}</span>
            </span>
          </div>
        </div>
      </div>
      <SvgIcon v-if="![1, 6].includes(tag.id)" icon="supervision-arrow-right" class="arrow-right-style" />

      <!-- 环节模块 -->
      <div v-if="![1,6,7].includes(tag.id)" class="other-info">
        <div class="name" :style="{color: tag.noAiType ? '#fff' : '#70788c'}">
          {{ tag.name }}
        </div>
        <div class="state" :style="{color: tag.color}">
          {{ tag.des }}
        </div>
      </div>

      <!-- 课后学模块 -->
      <div v-if="tag.id === 7" class="other-info">
        <div class="name">
          {{ tag.name }}
        </div>
        <div
          class="time-box"
          v-if="!!tag.isHighlight"
          :style="{background: tag.isHighlight === 1 ? '#3A3C48' : 'none'}"
        >
          <span class="time-icon" v-show="tag.isHighlight === 1">
            <span />
            <span />
            <span />
          </span>
          <!-- // 1：看课中，2：已看完 -->
          <span v-if="tag.isHighlight === 2" style="color: #98a2b2">已学完</span>
          <span v-else style="display: flex; margin-left: 4px">学习中</span>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import { computed } from '@vue/composition-api'
import filters from '@/filters'

export default {
  name: 'TagList',

  props: {
    moudleList: {
      type: Object,
      default: () => {}
    },
    period: {
      type: Number,
      default: 0
    },
    studyProgress: {
      type: [Array, null],
      default: () => []
    },
    isOldData: { // 老数据 学ai课和总进度处理
      type: Boolean,
      default: false
    }
  },

  setup(props, { root }) {
    const isWhiteOrg = computed(() => root.$store.state.userInfo.userInfo.teacherControl) // 白机构: true / false

    const notAiTypeCommit = {
      1: '已提交',
      2: '打回订正',
      3: '四星', // 对标原来的“已过关”
      4: '五星', // 对标原来的“优秀”
      5: '三星' // 1.4.6新增三星
    }

    const hasBeforeTag = computed(() => {
      const target = Array.isArray(props.studyProgress) && props.moudleList.find(k => k.id === 6)
      return target
    })

    const aiInfo = computed(() => {
      const target = Array.isArray(props.studyProgress) && props.studyProgress.find(k => k.sceneType === 1)
      if (target) {
        const isFinishAi = target.aiType === 2
        const studyTime = filters.msToMmSs(target.currentLearningDuration)
        const totalTime = filters.msToMmSs(target.totalLearningDuration)
        const progressVal = target.studyProgress

        return {
          fragmentIndex: target.fragmentIndex,
          fragmentTotal: target.fragmentTotal,
          fragmentName: target.fragmentName ? target.fragmentName : '--',
          studyProgress: target.studyProgress,
          isFinishAi,
          studyTime: studyTime.includes('NaN') ? false : studyTime, // 当前学习时长
          totalTime: totalTime.includes('NaN') ? false : totalTime, // 学习总时长
          progressVal,
          isOldData: props.isOldData,
          endPartNum: target.endPartNum, // 学过片段数量
          totalPartNum: target.totalPartNum // 总共片段数量
        }
      }
      return null
    })

    const getClass = tag => {
      if ([6, 7].includes(tag.id)) {
        // 1：看课中，2：已看完
        if (tag.isHighlight === 1) return 'other-normal before-after-playing-bk'
        if (tag.isHighlight === 2) return 'other-highlight before-after-highlight-bk'
        return 'other-normal before-after-normal-bk'
      }
      return tag.id === 1 ? 'ai-course' : tag.isHighlight ? 'other-highlight other-highlight-bk' : 'other-normal other-normal-bk'
    }

    const computedTagWidth = list => {
      const arr = list
      // 各标签宽度计算：key为tagList的长度，value为课中标签宽度的百分比，课中之外的tag宽度等分剩余空间
      const aiWidthMap = {
        1: 100,
        2: 86.5,
        3: 73,
        5: 28,
        6: 23,
        7: 19
      }
      const len = arr.length
      // eslint-disable-next-line array-callback-return
      if (len === 1) {
        arr[0].width = aiWidthMap[1]
      } else {
        arr.forEach(k => {
          k.width = k.id === 1 ? aiWidthMap[len] : Math.abs((100 - aiWidthMap[len]) / (len - 1))
        })
      }
      return arr
    }

    const tagList = computed(() => {
      const onlyAi = [1, 2].includes(props.period)
      const tagTypes = props.moudleList.map(k => k.id)
      const isInCludesBefore = tagTypes.includes(6)
      const isInCludesAfter = tagTypes.includes(7)

      let list = []
      if (onlyAi) {
        let before = props.studyProgress.find(k => k.sceneType === 6)
        let after = props.studyProgress.find(k => k.sceneType === 7)
        const target = props.moudleList.find(k => k.id === 1)

        if (isInCludesBefore) { // 课前
          before = {
            ...before,
            ...props.moudleList.find(k => k.id === 6),
            isHighlight: before && before.aiType // 类型（1：看课中，2：已看完）
          }
        }
        if (isInCludesAfter) { // 课后
          after = {
            ...props.moudleList.find(k => k.id === 7),
            isHighlight: after && after.aiType // 类型（1：看课中，2：已看完）
          }
        }

        list = [before, target, after].filter(item => item && item)
        const arr = computedTagWidth(list)
        return arr
      }
      // 获取所有需要展示的标签
      props.moudleList.forEach((tag, i) => {
        const target = Array.isArray(props.studyProgress) && props.studyProgress.find(k => k.sceneType === tag.id)
        const tagInfo = {
          ...tag,
          aiType: !!target && target.aiType,
          isHighlight: !!target,
          noAiType: target && target.noAiType,
          des: !target ? '' : notAiTypeCommit[target.noAiType] || '',
          color: target && target.noAiType === 2 ? '#FF8800' : '#98a2b2'
        }
        if (![6, 7].includes(tag.id)) { // 非课前和课后都push
          list.push(tagInfo)
        } else { // 只有包含课前或课后时才展示
          if (isInCludesBefore && tag.id === 6) {
            tagInfo.isHighlight = target ? target.aiType : undefined // 类型（1：看课中，2：已看完）
            list.unshift(tagInfo)
          }
          if (isInCludesAfter && tag.id === 7) {
            tagInfo.isHighlight = target ? target.aiType : undefined // 类型（1：看课中，2：已看完）
            list.push(tagInfo)
          }
        }
      })
      const arr = computedTagWidth(list)
      return arr
    })

    return {
      isWhiteOrg,
      getClass,
      hasBeforeTag,
      aiInfo,
      tagList
    }
  }
}
</script>

<style lang="less">
.tag-list {
    width: 100%;
    display: flex;
    margin-bottom: 0;
    progress {
        // transform: skewX(175deg);
        border-radius: 4px;
        height: 34px;
        &::-webkit-progress-bar{
            background-color: #4A4D5B;
            background-size: 50% 50%;
            background-repeat: no-repeat;
            border-radius: 4px;
        }
        &::-webkit-progress-value {
            background: #1E96FE;
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
        }
    }
    li {
        margin-right: 12px;
    }

    .ai-course {
        position: relative;
        margin-right: 4px;
        .progress-wrap {
          position: relative;
          .arrow-right-style {
            position: absolute;
            font-size: 34px;
            top: 0;
            left: -1px;
            fill: #2C2F3A;
          }
          .progress {
            width: 100%;
          }
        }
        .learn-ai {
            display: inline-block;
            white-space:nowrap;
            width: 90%;
            overflow: hidden;
            text-overflow: ellipsis;
            font-family: 'Microsoft YaHei UI';
            font-size: 14px;
            line-height: 22px;
            letter-spacing: 0.04em;
            color: #FFFFFF;
            position: absolute;
            left: 10px;
            top: 6px;
        }
        .total-progress {
          font-family: 'Microsoft YaHei UI';
          font-weight: 400;
          font-size: 14px;
          line-height: 12px;
          letter-spacing: 0.04em;
          color: #98A2B2;
          padding: 6px 0;
          display: flex;
          justify-content: center;
          border-radius: 4px;
          .time-icon {
            display: flex;
            width: 11px;
            justify-content: space-between;
            align-items: baseline;
            margin-right: 8px;
            >span {
              width: 2px;
              background: #06C270;
              border-radius: 4px;
              &:first-child {
                height: 7px;
              }
              &:nth-child(2) {
                height: 11px;
              }
              &:last-child {
                height: 4px;
              }
            }
          }
        }
        .time-box {
          width: 100%;
          // height: 24px;
          // line-height: 24px;
          // background: #3A3C48;
          border-radius: 4px;
          font-family: 'Microsoft YaHei UI';
          font-size: 12px;
          // line-height: 22px;
          letter-spacing: 0.04em;
          color: #C1C6D0;
          display: flex;
          align-items: center;
          justify-content: center;
          .timer {
              font-size: 14px;
              color: #98a2b2
          }
          .total {
              font-size: 12px;
              color: #98a2b2
          }
        }
        &:after {
            transform: translate(12%);
            content: "";
            width: 14px;
            height: 36px;
            position: absolute;
            right: 1px;
            top: -1px;
            background: url("../imgs/ai-course-right.png") no-repeat;
            background-size: 100% 100%;
        }
    }
    .other-normal, .other-highlight {
      width: 18%;
      height: 34px;
      font-family: 'Microsoft YaHei UI';
      font-size: 14px;
      line-height: 34px;
      position: relative;
      border-radius: 4px;
      padding-left: 15px;
      .other-info {
        position: relative;
        z-index: 1;
      }
      .name {
        height: 34px;
        white-space:nowrap;
        position: relative;
        left: -4px;
      }
      .state {
        margin-top: 5px;
        height: 24px;
        line-height: 24px;
      }
      .arrow-right-style {
        position: absolute;
        font-size: 34px;
        left: -1px;
        fill: #2C2F3A;
      }
      &:after {
        content: "";
        width: 16px;
        height: 16px;
        position: absolute;
        right: -6px;
        top: 9px;
        background: #4A4D5B;
        transform: scale(1, 1.5) rotate(45deg);
        border-radius: 2px;
      }
      .time-box {
        width: calc(100% + 10px + 12px);
        margin-left: -15px;
        margin-top: 5px;
        margin-top: 5.5px;
        height: 24px;
        line-height: 24px;
        background: #3A3C48;
        border-radius: 4px;
        font-family: 'Microsoft YaHei UI';
        font-size: 14px;
        line-height: 22px;
        letter-spacing: 0.04em;
        color: #C1C6D0;
        display: flex;
        align-items: center;
        justify-content: center;
        .time-icon {
          display: flex;
          width: 11px;
          justify-content: space-between;
          align-items: baseline;
          margin: 0 0 0 10px;
          >span {
            width: 2px;
            background: #06C270;
            border-radius: 4px;
            &:first-child {
              height: 7px;
            }
            &:nth-child(2) {
              height: 11px;
            }
            &:last-child {
              height: 4px;
            }
          }
        }
        .timer {
            font-size: 14px;
            color: #98a2b2
        }
        .total {
            font-size: 12px;
            color: #98a2b2
        }
      }
    }
    .other-normal-bk {
        background: #4A4D5B;
        color: #98A2B2;
        .name {
          color: #70788c;
        }
        &:after {
          background: #4A4D5B;
        }
    }
    .other-highlight-bk {
      background: #A259FF;
      color: #fff;
      .name {
        color: #70788c;
      }
      &:after {
          background: #A259FF;
      }
    }

    .before-after-playing-bk {
        background: #284e75;
        color: #fff;
        .name {
          color: #fff;
        }
        &:after {
          background: #284e75;
        }
    }
    .before-after-highlight-bk {
      background: #1E96FE;
      color: #fff;
      .name {
        color: #fff;
      }
      &:after {
          background: #1E96FE;
      }
    }
    .before-after-normal-bk {
      background: #4A4D5B;
      color: #70788c;
      .name {
        color: #70788c;
      }
      &:after {
          background: #4A4D5B;
      }
    }
}
</style>